import { activities as enActivities } from "@/i18n/locales/en-gb.json";
import { snakeToTitle } from "@/lib/utils";
import { createTaxonomyFormatter, type Translator } from "./formatTaxonomy";

const enActivityNames = enActivities as Record<string, string>;

/**
 * A minimal English translator covering only the `activities.*` keys, which is
 * all {@link createTaxonomyFormatter}'s `activity()` ever looks up. We resolve
 * against the imported English messages directly rather than spinning up a full
 * next-intl translator — no provider, no extra bundle weight, works in tests.
 */
const toActivityKey = (key: string) =>
  key.startsWith("activities.") ? key.slice("activities.".length) : key;

const englishTranslator: Translator = Object.assign(
  (key: string) => {
    const activityKey = toActivityKey(key);
    return enActivityNames[activityKey] ?? snakeToTitle(activityKey);
  },
  { has: (key: string) => toActivityKey(key) in enActivityNames },
);

/**
 * A taxonomy formatter permanently bound to English, independent of the user's
 * current locale. Used to let searches match the English activity name too, so
 * e.g. an English speaker on the Norwegian page can type "run" and find "Løping".
 *
 * Only the `activities` slice of the English messages is imported (not the whole
 * locale file), so this adds almost nothing to the bundle for non-English users.
 */
export const englishTaxonomyFormatter =
  createTaxonomyFormatter(englishTranslator);
